import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { ContactEngagement } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<ContactEngagement, unknown>[] = [
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.engagementLastContactStaffId), { header: 'Last Contacted By' }),
		buildColumn(util, 'Id', row => row.id, { header: 'engagementId' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.engagementLastContactUTC), { header: 'Last Contacted Date' }),
		buildColumn(util, 'Text', row => row.details, { width: 150 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.followUpDateUTC), { header: 'Follow Up' }),
	];

	return columns;

}